export class Customer {
  id: number;

  name: string;
  identification: string;
  phone: string;
  address: string;
  district: string;
  coords: string;

  email: string;

  description: string;
  additional_info: string;

  token: string;

  // timestamps
  created_at: string;
  updated_at: string;


  // set by our front end app
  surname: string;

  static fixSurname(customer: Customer) {
    if(customer && (!customer.surname || customer.surname.length == 0)) {
      let aux = customer.name.split(" ");
      aux.splice(0,1);
      customer.surname = aux.join(" ");
      customer.name = customer.name.split(" ")[0];
    }
  }
}